import {Box, Container, Typography} from "@mui/material";

export default function Statement() {

    return (
        <Container
            maxWidth={"lg"}
        >
            <Box
                maxWidth={"sm"}
                py={24}
            >
                <Typography variant={"h4"} fontWeight={"bold"} paddingBottom={2}>
                    A more thoughtful way to meet new people.
                </Typography>
                <Typography variant={"body1"} paddingBottom={2}>
                    We live in an age of unprecedented connectedness, but paradoxically, it's become
                    harder than ever to find connection.
                    Tapping, liking, swiping. All of it superficial, none of it quite leading anywhere.
                </Typography>
                <Typography variant={"body1"} paddingBottom={1}>
                    Surely there is a better way to do this, you ask? There is.
                    We just have to be more considered and thoughtful in the way we go about it.
                    And it starts with the platform.
                </Typography>
                <Typography variant={"body1"} paddingBottom={1}>
                    <i>Personally</i> replicates the slow-burn, more intentional experiences of the internet's earlier years.
                    It's personal ads, modernised and redesigned for the digital era.
                </Typography>
            </Box>
        </Container>
    );
}